import { SearchMode } from '#pplx/frontend/ask-models/types/search-modes.js';
import { AccessLevel } from '#pplx/frontend/components/types/types.js';
export function getHomeComputerProjectTarget({ selectedProject, selectedSearchMode, }) {
    const shouldTargetProject = selectedSearchMode === SearchMode.ASI && selectedProject != null;
    return {
        collection: shouldTargetProject ? selectedProject.targetCollection : null,
        targetThreadAccessLevel: shouldTargetProject ? AccessLevel.COLLECTION_READ : undefined,
    };
}
//# sourceMappingURL=getHomeComputerProjectTarget.js.map